import { Navbar, Button } from 'react-bootstrap';
import { IProfile } from '../models/profile';
import { Link, useNavigate } from 'react-router-dom';
import { HomeFilled, InfoFilled, PersonFilled } from '@fluentui/react-icons';

export interface INavigationBarProps {
    user: IProfile;
    setUser: (profile: IProfile) => void;
}

export const NavigationBar = (props: INavigationBarProps) => {
    const initialState : IProfile = { userid: 0, username: '', displayname: '', roles: [] };
    const navigate = useNavigate();
     const { user, setUser } = props;
    
    const login = async () => {
        await navigate('/login');
    }

    const logout = async () => {
        localStorage.removeItem("token");
        localStorage.removeItem("account");
        setUser(initialState);
        await navigate('/');
    }

    console.log("NavigationBar user: ", user);

    return (
        <>
            <Navbar bg="primary" variant="dark" className={`navbarStyle navProd`}>
                <a className="navbar-brand" href="/">
                    <img src={`${process.env.PUBLIC_URL}/img/logo_inpistaconilcuore.png`} style={{ width: "50px", marginLeft: "10px" }} />
                </a>
                <div style={{width:'100%'}}>
                    <div className="collapse navbar-collapse justify-content-end">
                        <div>
                            <Link to="" className='navbar-brand menu' style={{fontSize:"1.5em"}}><HomeFilled /></Link>
                        </div>
                        <div>
                            <Link to="info" className='navbar-brand menu' style={{fontSize:"1.5em"}}><InfoFilled /></Link>
                        </div>
                        {
                            user.userid !== 0 &&
                            <div>
                                <Link to="profile" className='navbar-brand menu' style={{fontSize:"1.6em"}}><PersonFilled /></Link>
                            </div> 
                        }
                        {user && user.roles && user.roles.filter(r => r.RoleName === "Administrator").length > 0 && 
                            <>
                                <div>
                                    <Link to="adminauctions" className='navbar-brand menu' style={{color: "orange"}}>Aste</Link>
                                </div>
                                <div>
                                    <Link to="adminusers" className='navbar-brand menu' style={{color: "orange"}}>Utenti</Link>
                                </div>
                            </>
                        }
                        {
                            user.userid === 0 &&
                            <div style={{marginRight: "10px"}}>
                                <Button onClick={login}>Accedi</Button>
                            </div> 
                        }
                        {
                            user.userid !== 0 && 
                            <div style={{marginRight: "10px"}}>
                                <Button variant="warning" onClick={logout}>Esci</Button>                            
                            </div> 
                        }                    
                    </div>
                </div>
            </Navbar>
        </>
    );
};